import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AppCookieService {
  private cookieStore = {};

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.parseCookies(document.cookie);
    }
  }

  public parseCookies(cookies = document.cookie) {
    this.cookieStore = {};
    if (!!cookies === false) {
      return;
    }
    const cookiesArr = cookies.split(';');
    for (const cookie of cookiesArr) {
      const cookieArr = cookie.split('=');
      this.cookieStore[cookieArr[0].trim()] = cookieArr[1];
    }
  }

  get(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.parseCookies();
    }
    return !!this.cookieStore[key] ? this.cookieStore[key] : null;
  }

  setExpCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  set(key: string, value: string) {
    if (isPlatformBrowser(this.platformId)) {
      document.cookie = key + '=' + (value || '');
    }
  }

  remove(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
  }

  clear() {
    if (isPlatformBrowser(this.platformId)) {
      Object.keys(this.cookieStore).forEach((key) => {
        try {
          // Attempt to remove the cookie
          this.remove(key);
        } catch (error) {
          // Handle any errors that occur during removal
          console.error(`Error removing cookie with key ${key}: ${error}`);
        }
      });
    }
  }
}
